export type DeployTypes = 'CDK'

export const Deploy: { [k in DeployTypes]: k } = {
  CDK: 'CDK',
}

export type StackDeployDefinition = {
  /** the name used in the deployment menu and settings.ts */
  friendlyName: string
  /** the deployed stack name */
  stackName: string
  /** the lsc relative path to the project root */
  root: string
  /** the cloud kit type -- as of around 2024 01 this is solely CDK */
  type: DeployTypes
  /** an optional script to run before CDK. This cannot set env vars to be used by CDK as it is run as a separate process */
  build?: string
  /** if true, deployment utility skips compilation, eg for projects where no code is deployed */
  noCompile?: boolean
  /** substacks of the main stack */
  substacks: { [k: string]: string }
  /** an optional array of scripts which will be run in the same process as cdk synth|deploy etc. This WILL allow env vars to be passed to CDK */
  preCDKScripts?: string[]
  /** an optional description which (currently only on external stacks, pending migration) will appear in Cloudformation */
  description?: string
}
